/* Growing Minds Garden — interactions
   Keep it light: sticky header, mobile nav, scroll reveal,
   FAQ accordion, and the "which mother are you" village picker. */
(function () {
  'use strict';

  /* ---- sticky header shadow ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- mobile nav ---- */
  var toggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    var closeBtn = mobileNav.querySelector('.mobile-nav__close');
    var open = function () { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; };
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  }

  /* ---- notify-me popup for Coming-Soon product cards (task-0995) ----
     Hub cards no longer link to product/landing pages (pricing is placeholder).
     Each card carries data-product-tag + data-product-title; clicking opens this
     one shared dialog, sets its heading, and folds the product-* tag into the
     reused newsletter-form's contact[tags] radios (each radio's base value is
     captured once) before opening — so the signup is tagged per product. */
  var notifyModal = document.querySelector('[data-notify-modal]');
  if (notifyModal) {
    var notifyForm = notifyModal.querySelector('.newsletter__form');
    var notifyRadios = notifyForm ? notifyForm.querySelectorAll('input[name="contact[tags]"]') : [];
    notifyRadios.forEach(function (r) { r.dataset.notifyBase = r.value; });
    var notifyTitle = notifyModal.querySelector('[data-notify-title]');
    var openNotify = function (tag, title) {
      if (notifyTitle && title) notifyTitle.textContent = 'Notify me when ' + title + ' is ready';
      notifyRadios.forEach(function (r) { r.value = r.dataset.notifyBase + (tag ? ',' + tag : ''); });
      if (typeof notifyModal.showModal === 'function') notifyModal.showModal();
      else notifyModal.setAttribute('open', '');
    };
    var closeNotify = function () { if (typeof notifyModal.close === 'function') notifyModal.close(); else notifyModal.removeAttribute('open'); };
    document.querySelectorAll('[data-notify]').forEach(function (card) {
      card.addEventListener('click', function () { openNotify(card.getAttribute('data-product-tag'), card.getAttribute('data-product-title')); });
    });
    var notifyCloseBtn = notifyModal.querySelector('[data-notify-close]');
    if (notifyCloseBtn) notifyCloseBtn.addEventListener('click', closeNotify);
    notifyModal.addEventListener('click', function (e) { if (e.target === notifyModal) closeNotify(); });
  }

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- hero photo parallax (task-0908; task-0913: photo is now Annetta's
     real tulip-field/tree-line shot, same drift treatment) ----
     The photo layer drifts at ~12% of scroll speed while the hero scrolls
     away — transform-only, rAF-throttled, skipped for reduced motion. */
  var canopy = document.querySelector('[data-parallax]');
  if (canopy && !reduceMotion && 'requestAnimationFrame' in window) {
    var heroEl = canopy.closest('.hero-brand');
    var pxTicking = false;
    var pxUpdate = function () {
      pxTicking = false;
      var max = heroEl ? heroEl.offsetHeight : 600;
      var y = Math.min(window.scrollY, max) * 0.12;
      canopy.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    };
    window.addEventListener('scroll', function () {
      if (!pxTicking) { pxTicking = true; window.requestAnimationFrame(pxUpdate); }
    }, { passive: true });
    pxUpdate();
  }

  /* ---- scroll reveal ---- */
  /* task-0908: grids marked data-stagger cascade their children in; once an
     element has fully entered, the reveal classes and inline delay are removed
     so card/button hover transitions behave exactly as before the entrance. */
  document.querySelectorAll('[data-stagger]').forEach(function (wrap) {
    wrap.querySelectorAll('.reveal').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.07).toFixed(2) + 's';
    });
  });
  var settle = function (el) {
    el.classList.remove('reveal', 'is-in');
    el.style.transitionDelay = '';
  };
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var delay = parseFloat(getComputedStyle(el).transitionDelay) || 0;
          el.classList.add('is-in');
          /* draw-in flourishes keep their own class so they survive settle */
          el.querySelectorAll('[data-flourish]').forEach(function (f) { f.classList.add('is-drawn'); });
          io.unobserve(el);
          setTimeout(function () { settle(el); }, delay * 1000 + 1000);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) {
      el.classList.add('is-in');
      el.querySelectorAll('[data-flourish]').forEach(function (f) { f.classList.add('is-drawn'); });
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq__item');
      var ans = item.querySelector('.faq__a');
      var isOpen = item.classList.toggle('is-open');
      ans.style.maxHeight = isOpen ? ans.scrollHeight + 'px' : '0px';
      btn.setAttribute('aria-expanded', isOpen);
    });
  });

  /* ---- village picker (v2: animated bloom result + real next-step link) ---- */
  var village = document.querySelector('[data-village]');
  if (village) {
    var cards = village.querySelectorAll('.village__card');
    var out = village.parentNode.querySelector('[data-village-result]');
    var outText = out && out.querySelector('[data-village-text]');
    var outLink = out && out.querySelector('[data-village-link]');
    var outLinkLabel = out && out.querySelector('[data-village-link-label]');
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        cards.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        c.classList.add('is-active');
        c.setAttribute('aria-pressed', 'true');
        if (!out) return;
        if (outText) outText.textContent = c.getAttribute('data-result') || '';
        var link = c.getAttribute('data-link');
        var label = c.getAttribute('data-link-label');
        if (outLink) {
          if (link && link !== '#' && label) {
            outLink.href = link;
            if (outLinkLabel) outLinkLabel.textContent = label;
            outLink.hidden = false;
          } else {
            outLink.hidden = true;
          }
        }
        /* retrigger the bloom + stem-grow animation on every pick */
        out.classList.remove('is-in');
        void out.offsetWidth;
        out.classList.add('is-in');
      });
    });
  }

  /* ═══ botanical system (task-0909, reworked task-0916) ═══
     One shared illustrated vocabulary — three leaf shapes, a curling
     tendril and a five-petal bloom, all with a soft offset-shadow
     underlay so nothing reads as flat clip-art — used by BOTH the
     scroll-growing vine and the garden accents (corner sprigs, drifting
     leaves) so the whole site feels like one hand-drawn garden. */
  var NS = 'http://www.w3.org/2000/svg';
  var rootCS = getComputedStyle(document.documentElement);
  var cvar = function (n, fb) { return (rootCS.getPropertyValue(n) || '').trim() || fb; };
  var PINE = cvar('--c-forest', '#2F6C3F');
  var DEEP = cvar('--c-forest-deep', '#204E2F');
  var MEADOW = cvar('--c-green-med', '#A6C48E');
  /* task-0912: blooms stay plum — purple is out of the palette */
  var BLOOM = cvar('--c-plum', '#765D78');
  var SUN = cvar('--c-buttercup', '#FFE173');

  /* deterministic 0..1 noise — organic variation without flicker on rebuild */
  var nz = function (i) { var x = Math.sin(i * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); };

  var shadowOf = function (d) {
    return '<path d="' + d + '" transform="translate(1.1,1.5)" fill="' + DEEP + '" fill-opacity=".14" stroke="none"/>';
  };
  /* leaf 1: classic pointed leaf with a drawn center vein */
  var leafSimple = function (fill, flip, s) {
    var f = flip * s;
    var d = 'M0 0 C' + (9.5 * f).toFixed(1) + ' -3.5, ' + (16 * f).toFixed(1) + ' ' + (-10.5 * s).toFixed(1) + ', ' + (17.5 * f).toFixed(1) + ' ' + (-20.5 * s).toFixed(1) +
      ' C' + (7 * f).toFixed(1) + ' ' + (-17.5 * s).toFixed(1) + ', ' + (1.6 * f).toFixed(1) + ' ' + (-8.5 * s).toFixed(1) + ', 0 0 Z';
    var vein = 'M' + (1.4 * f).toFixed(1) + ' -2 C' + (5.5 * f).toFixed(1) + ' ' + (-6 * s).toFixed(1) + ', ' + (9.5 * f).toFixed(1) + ' ' + (-10.5 * s).toFixed(1) + ', ' + (12.5 * f).toFixed(1) + ' ' + (-15.5 * s).toFixed(1);
    return shadowOf(d) +
      '<path d="' + d + '" fill="' + fill + '" stroke="' + DEEP + '" stroke-width="1" stroke-opacity=".5" stroke-linejoin="round"/>' +
      '<path d="' + vein + '" fill="none" stroke="' + DEEP + '" stroke-width=".85" stroke-opacity=".55" stroke-linecap="round"/>';
  };
  /* leaf 2: two-lobe sprig on a short stalk */
  var leafPair = function (fill, flip, s) {
    var f = flip * s;
    var stalk = 'M0 0 C' + (3.5 * f).toFixed(1) + ' ' + (-5 * s).toFixed(1) + ', ' + (6 * f).toFixed(1) + ' ' + (-11 * s).toFixed(1) + ', ' + (6.5 * f).toFixed(1) + ' ' + (-17 * s).toFixed(1);
    var l1 = 'M' + (4.8 * f).toFixed(1) + ' ' + (-9 * s).toFixed(1) + ' C' + (10.5 * f).toFixed(1) + ' ' + (-10 * s).toFixed(1) + ', ' + (14.5 * f).toFixed(1) + ' ' + (-13.5 * s).toFixed(1) + ', ' + (16 * f).toFixed(1) + ' ' + (-19 * s).toFixed(1) +
      ' C' + (9.5 * f).toFixed(1) + ' ' + (-17.5 * s).toFixed(1) + ', ' + (5.8 * f).toFixed(1) + ' ' + (-13.5 * s).toFixed(1) + ', ' + (4.8 * f).toFixed(1) + ' ' + (-9 * s).toFixed(1) + ' Z';
    var l2 = 'M' + (6.5 * f).toFixed(1) + ' ' + (-17 * s).toFixed(1) + ' C' + (4.2 * f).toFixed(1) + ' ' + (-22.5 * s).toFixed(1) + ', ' + (5 * f).toFixed(1) + ' ' + (-27.5 * s).toFixed(1) + ', ' + (8.5 * f).toFixed(1) + ' ' + (-31 * s).toFixed(1) +
      ' C' + (10 * f).toFixed(1) + ' ' + (-26 * s).toFixed(1) + ', ' + (9 * f).toFixed(1) + ' ' + (-21 * s).toFixed(1) + ', ' + (6.5 * f).toFixed(1) + ' ' + (-17 * s).toFixed(1) + ' Z';
    return shadowOf(l1) + shadowOf(l2) +
      '<path d="' + stalk + '" fill="none" stroke="' + DEEP + '" stroke-width="1.1" stroke-opacity=".6" stroke-linecap="round"/>' +
      '<path d="' + l1 + '" fill="' + fill + '" stroke="' + DEEP + '" stroke-width=".9" stroke-opacity=".45" stroke-linejoin="round"/>' +
      '<path d="' + l2 + '" fill="' + fill + '" stroke="' + DEEP + '" stroke-width=".9" stroke-opacity=".45" stroke-linejoin="round"/>';
  };
  /* leaf 3: curling tendril, pure line — the hand-drawn gesture */
  var tendril = function (stroke, flip, s) {
    var f = flip * s;
    var d = 'M0 0 C' + (7 * f).toFixed(1) + ' ' + (-3 * s).toFixed(1) + ', ' + (12 * f).toFixed(1) + ' ' + (-9 * s).toFixed(1) + ', ' + (10.5 * f).toFixed(1) + ' ' + (-14.5 * s).toFixed(1) +
      ' C' + (9 * f).toFixed(1) + ' ' + (-18.5 * s).toFixed(1) + ', ' + (4.5 * f).toFixed(1) + ' ' + (-18 * s).toFixed(1) + ', ' + (4.2 * f).toFixed(1) + ' ' + (-14.5 * s).toFixed(1) +
      ' C' + (4 * f).toFixed(1) + ' ' + (-12 * s).toFixed(1) + ', ' + (6.5 * f).toFixed(1) + ' ' + (-11 * s).toFixed(1) + ', ' + (8 * f).toFixed(1) + ' ' + (-12.5 * s).toFixed(1);
    return '<path d="' + d + '" fill="none" stroke="' + stroke + '" stroke-width="1.4" stroke-opacity=".8" stroke-linecap="round"/>';
  };
  /* five-petal bloom with per-petal jitter so no two feel stamped */
  var bloomMarkup = function (r, seed) {
    var out = '<circle cx="1.2" cy="1.6" r="' + (r * 1.7).toFixed(1) + '" fill="' + DEEP + '" fill-opacity=".10"/>';
    for (var i = 0; i < 5; i++) {
      var rx = r * 0.62 * (0.92 + 0.18 * nz(seed + i));
      var ry = r * 1.05 * (0.94 + 0.14 * nz(seed + i + 9));
      var rot = i * 72 + (nz(seed + i + 17) - 0.5) * 16;
      out += '<ellipse cx="0" cy="' + (-r * 1.02).toFixed(1) + '" rx="' + rx.toFixed(1) + '" ry="' + ry.toFixed(1) + '" transform="rotate(' + rot.toFixed(1) + ' 0 0)" fill="' + BLOOM + '" stroke="' + DEEP + '" stroke-width=".8" stroke-opacity=".38"/>';
    }
    out += '<circle r="' + (r * 0.52).toFixed(1) + '" fill="' + SUN + '" stroke="' + DEEP + '" stroke-width=".8" stroke-opacity=".4"/>';
    for (var k = 0; k < 3; k++) {
      out += '<circle cx="' + ((nz(seed + k + 31) - 0.5) * r * 0.55).toFixed(1) + '" cy="' + ((nz(seed + k + 41) - 0.5) * r * 0.55).toFixed(1) + '" r="' + (r * 0.09).toFixed(1) + '" fill="' + DEEP + '" fill-opacity=".5"/>';
    }
    return out;
  };

  /* task-0914 r3: computed background colors from color-mix() come back as
     "color(srgb 0.98 ...)" (0–1 channels) — the old regex parse read those
     pastels as near-black, so pastel bands got light art on light ground
     (washed out). A 1×1 canvas resolves ANY css color to true rgba. */
  var lumCanvas = document.createElement('canvas');
  lumCanvas.width = lumCanvas.height = 1;
  var lumCtx = lumCanvas.getContext('2d', { willReadFrequently: true });
  var lumOf = function (str) {
    if (!str || !lumCtx) return null;
    lumCtx.clearRect(0, 0, 1, 1);
    lumCtx.fillStyle = 'rgba(0,0,0,0)';
    try { lumCtx.fillStyle = str; } catch (e) { return null; }
    lumCtx.fillRect(0, 0, 1, 1);
    var d = lumCtx.getImageData(0, 0, 1, 1).data;
    if (d[3] === 0) return null;
    return (0.299 * d[0] + 0.587 * d[1] + 0.114 * d[2]) / 255;
  };
  /* effective band luminance: walk up to the first painted background.
     null = a photo band (background-image) — luminance unknowable. */
  var effLum = function (el) {
    var n = el;
    while (n && n !== document.documentElement) {
      var cs = getComputedStyle(n);
      var l = lumOf(cs.backgroundColor);
      if (l != null) return l;
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return null;
      n = n.parentElement;
    }
    return 0.96; /* page cream */
  };
  var isDarkBg = function (el) {
    var l = effLum(el);
    return l != null && l < 0.5;
  };
  var docTop = function (el) { return el.getBoundingClientRect().top + window.scrollY; };

  /* ---- scroll-growing vine (task-0909, rebuilt task-0916) ----
     Joey's 2026-08-22 feedback, verbatim goals: "more wiggly and dynamic
     and fun", not "too vertical", must not run "too far down the
     viewpane", and should "thoughtful[ly] divert eye attention".
     So the path is no longer a near-vertical line with 3 bends:
     - EYE-GUIDE: it finds the actual headlines and CTAs of the sections
       it passes and swings INWARD to almost touch the content edge at
       each one (a plum bloom marks the spot), then wanders back out —
       the line literally leans toward what you should read next.
     - WIGGLE: between those anchor points it meanders on a phase-shifted
       sine with noise, so every ~250px it is somewhere else in the
       gutter band instead of hugging one x position.
     - VIEWPORT REST: the growing tip now rides at ~58% of the viewport
       height (was 92%), so the vine settles in the upper half and never
       dominates the whole visible pane.
     - TAPER: drawn as 10 chained segments whose stroke narrows from
       ~4.8px at the root to ~1.8px at the tip.
     Reduced motion: fully drawn, static, no listeners. */
  if (document.body.classList.contains('template-index')) {
    var vineWrap = null, vineGlow = null, glowLen = 0;
    var vineLen = 0, vineHpx = 1, vineTopDoc = 0, vineSprigs = [], vineSegs = [];

    var buildVine = function () {
      var sections = Array.prototype.slice.call(document.querySelectorAll('.section, .garden-band'));
      if (sections.length < 4) return;
      if (vineWrap) { vineWrap.parentNode.removeChild(vineWrap); vineWrap = null; }
      vineSprigs = []; vineSegs = [];

      var startY = docTop(sections[0]) + 70;
      var bounds = [docTop(sections[1]), docTop(sections[2]), docTop(sections[3])];
      var endY = bounds[2] + 150;
      var H = Math.max(1, endY - startY);

      var wrapW = Math.min(1240, window.innerWidth * 0.92);
      var gutter = (window.innerWidth - wrapW) / 2;
      var mobile = gutter < 60;
      /* the vine lives in a band hugging the content column, not the far
         screen edge — on wide monitors it stays near what you're reading */
      var bandW = mobile ? Math.max(22, gutter + 8) : Math.min(Math.max(gutter - 14, 70), 150);
      var left = mobile ? 0 : Math.max(2, gutter - bandW - 6);

      vineWrap = document.createElement('div');
      vineWrap.className = 'gmg-vine';
      vineWrap.setAttribute('aria-hidden', 'true');
      vineWrap.style.top = startY + 'px';
      vineWrap.style.left = left + 'px';
      vineWrap.style.width = bandW + 'px';
      vineWrap.style.height = H + 'px';
      /* task-0916: mobile no longer washed out at .55 — the thinner stroke
         + gutter band keep it polite, so it can be genuinely visible */
      vineWrap.style.opacity = mobile ? '.9' : '1';

      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('width', bandW);
      svg.setAttribute('height', H);
      svg.setAttribute('viewBox', '0 0 ' + bandW + ' ' + H);

      /* task-0914 r4: a seam that carries a centered medallion gets a QUIET
         zone — the vine may still cross it (continuity), but inside the zone
         it hugs the outer screen edge and drops all sprigs/blooms/anchor
         pulls, so the medallion stays that seam's only focal element. The
         medallions are already in the DOM here (buildAccents runs at
         DOMContentLoaded, the vine at load) so we just read them. */
      var QUIET = mobile ? 110 : 150;
      var medSeamYs = [];
      document.querySelectorAll('.gmg-seam--center').forEach(function (md) {
        var mr = md.getBoundingClientRect();
        var my = mr.top + mr.height / 2 + window.scrollY - startY;
        if (my > -QUIET && my < H + QUIET) medSeamYs.push(my);
      });
      var nearMedSeam = function (y) {
        for (var q = 0; q < medSeamYs.length; q++) { if (Math.abs(medSeamYs[q] - y) < QUIET) return true; }
        return false;
      };

      /* eye-guide anchors: each passed section's headline + first CTA */
      var anchors = [];
      sections.slice(0, 4).forEach(function (sec, si) {
        [sec.querySelector('h1, h2'), sec.querySelector('.btn')].forEach(function (el, which) {
          if (!el) return;
          var y = docTop(el) + Math.min(el.offsetHeight, 90) * 0.5 - startY;
          if (y < 90 || y > H - 90 || nearMedSeam(y)) return;
          anchors.push({ y: y, cta: which === 1, seed: si * 7 + which * 3 + 2 });
        });
      });
      anchors.sort(function (a, b) { return a.y - b.y; });
      var kept = [];
      anchors.forEach(function (a) {
        if (!kept.length || a.y - kept[kept.length - 1].y > 260) kept.push(a);
      });

      /* waypoints: meander between anchors, pull hard inward at each one */
      var inX = bandW - 10, loX = mobile ? 4 : 9;
      var phase = nz(3) * Math.PI;
      var pts = [{ x: bandW * 0.42, y: 4 }];
      var addWiggles = function (fromY, toY, seedBase) {
        var gap = toY - fromY;
        var n = Math.max(2, Math.round(gap / (mobile ? 165 : 190)));
        for (var k = 1; k < n; k++) {
          phase += 2.15 + nz(seedBase + k) * 1.5;
          var x = bandW * (0.46 + 0.44 * Math.sin(phase));
          var wy = fromY + gap * (k / n);
          /* r4: tuck the crossing against the outer edge inside a QUIET zone */
          if (nearMedSeam(wy)) x = Math.min(x, bandW * 0.3);
          pts.push({ x: Math.max(loX, Math.min(inX - 6, x)), y: wy });
        }
      };
      var cursor = 4;
      kept.forEach(function (a, ai) {
        addWiggles(cursor, a.y, a.seed + ai * 13);
        pts.push({ x: inX, y: a.y, anchor: a });
        cursor = a.y;
      });
      addWiggles(cursor, H - 6, 97);
      pts.push({ x: bandW * 0.35, y: H - 6 });

      /* Catmull-Rom → cubic bezier: one continuous curve through every
         waypoint, control x clamped so it never crosses into content */
      var clx = function (v) { return Math.max(2, Math.min(bandW - 2, v)); };
      var d = 'M' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[Math.max(0, i - 1)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(pts.length - 1, i + 2)];
        d += ' C' + clx(p1.x + (p2.x - p0.x) / 6).toFixed(1) + ' ' + (p1.y + (p2.y - p0.y) / 6).toFixed(1) +
          ', ' + clx(p2.x - (p3.x - p1.x) / 6).toFixed(1) + ' ' + (p2.y - (p3.y - p1.y) / 6).toFixed(1) +
          ', ' + p2.x.toFixed(1) + ' ' + p2.y.toFixed(1);
      }

      /* per-section stroke color: light stem over dark bands, pine over light */
      var defs = document.createElementNS(NS, 'defs');
      var grad = document.createElementNS(NS, 'linearGradient');
      grad.setAttribute('id', 'gmgVineGrad');
      grad.setAttribute('gradientUnits', 'userSpaceOnUse');
      grad.setAttribute('x1', '0'); grad.setAttribute('y1', '0');
      grad.setAttribute('x2', '0'); grad.setAttribute('y2', H);
      var bandColor = function (y) {
        var idx = 0;
        for (var k = 0; k < bounds.length; k++) { if (y + startY >= bounds[k]) idx = k + 1; }
        return isDarkBg(sections[idx]) ? MEADOW : PINE;
      };
      var stopAt = function (y, col) {
        var s = document.createElementNS(NS, 'stop');
        s.setAttribute('offset', Math.max(0, Math.min(1, y / H)));
        s.setAttribute('stop-color', col);
        grad.appendChild(s);
      };
      stopAt(0, bandColor(0));
      for (var g2 = 0; g2 < bounds.length; g2++) {
        var by = bounds[g2] - startY;
        stopAt(by - 26, bandColor(by - 26));
        stopAt(by + 26, bandColor(by + 26));
      }
      stopAt(H, bandColor(H - 1));
      defs.appendChild(grad);
      svg.appendChild(defs);

      /* master path: measurement + glow geometry (itself invisible) */
      var master = document.createElementNS(NS, 'path');
      master.setAttribute('d', d);
      master.setAttribute('fill', 'none');
      master.setAttribute('stroke', 'none');
      svg.appendChild(master);

      var glow = document.createElementNS(NS, 'path');
      glow.setAttribute('d', d);
      glow.setAttribute('fill', 'none');
      glow.setAttribute('stroke', 'rgba(166,196,142,.26)');
      glow.setAttribute('stroke-width', mobile ? 4.5 : 8);
      glow.setAttribute('stroke-linecap', 'round');
      svg.appendChild(glow);

      var masterLen = master.getTotalLength();
      /* tapered stem: 10 chained polyline segments, root → tip widths */
      var samples = [];
      for (var sL = 0; sL < masterLen; sL += 6) samples.push(master.getPointAtLength(sL));
      samples.push(master.getPointAtLength(masterLen));
      var SEGN = 10;
      var wBase = mobile ? 3.1 : 4.8, wTip = mobile ? 1.4 : 1.8;
      var acc = 0;
      for (var si2 = 0; si2 < SEGN; si2++) {
        var i0 = Math.floor(si2 * (samples.length - 1) / SEGN);
        var i1 = Math.floor((si2 + 1) * (samples.length - 1) / SEGN);
        var dd = 'M' + samples[i0].x.toFixed(1) + ' ' + samples[i0].y.toFixed(1);
        for (var j = i0 + 1; j <= i1; j++) dd += 'L' + samples[j].x.toFixed(1) + ' ' + samples[j].y.toFixed(1);
        var sp = document.createElementNS(NS, 'path');
        sp.setAttribute('d', dd);
        sp.setAttribute('fill', 'none');
        sp.setAttribute('stroke', 'url(#gmgVineGrad)');
        sp.setAttribute('stroke-width', (wBase + (wTip - wBase) * (si2 / (SEGN - 1))).toFixed(2));
        sp.setAttribute('stroke-linecap', 'round');
        sp.setAttribute('stroke-linejoin', 'round');
        svg.appendChild(sp);
        var segLen = sp.getTotalLength();
        sp.style.strokeDasharray = segLen;
        sp.style.strokeDashoffset = segLen;
        vineSegs.push({ el: sp, start: acc, len: segLen });
        acc += segLen;
      }
      vineLen = acc;
      glowLen = glow.getTotalLength();
      glow.style.strokeDasharray = glowLen;
      glow.style.strokeDashoffset = glowLen;

      vineWrap.appendChild(svg);
      document.body.appendChild(vineWrap);
      vineHpx = H;
      vineTopDoc = startY;

      /* leaf sprigs: 3 rotating shapes, varied scale, both sides; kept
         clear of the anchor blooms so each "look here" moment stays clean */
      var sprigScale = mobile ? 0.6 : 1;
      var step = mobile ? 175 : 150;
      var side = 1, li = 0;
      var nearAnchor = function (y) {
        for (var q = 0; q < kept.length; q++) { if (Math.abs(kept[q].y - y) < 70) return true; }
        return false;
      };
      for (var L = 55; L < masterLen - 70; L += step) {
        var p1a = master.getPointAtLength(L);
        if (nearAnchor(p1a.y) || nearMedSeam(p1a.y)) continue;
        var p2a = master.getPointAtLength(Math.min(masterLen, L + 8));
        var ang = Math.atan2(p2a.y - p1a.y, p2a.x - p1a.x) * 180 / Math.PI;
        var outer = document.createElementNS(NS, 'g');
        outer.setAttribute('transform', 'translate(' + p1a.x.toFixed(1) + ',' + p1a.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
        var sg = document.createElementNS(NS, 'g');
        sg.setAttribute('class', 'gmg-sprig');
        var fill = bandColor(p1a.y);
        var sc = sprigScale * (0.8 + 0.45 * nz(li + 5));
        var kind = li % 3;
        sg.innerHTML = kind === 0 ? leafSimple(fill, side, sc)
          : kind === 1 ? leafPair(fill, side, sc * 0.9)
            : tendril(fill === MEADOW ? MEADOW : PINE, side, sc);
        sg.dataset.len = Math.round(L);
        outer.appendChild(sg);
        svg.appendChild(outer);
        vineSprigs.push(sg);
        side *= -1; li++;
      }
      /* a bloom at every eye-guide anchor — the "look here" punctuation
         (CTAs get the bigger flower) */
      kept.forEach(function (a, bi) {
        var bestL = 0, bestDist = Infinity;
        for (var s2 = 0; s2 <= masterLen; s2 += 18) {
          var pp = master.getPointAtLength(s2);
          var dist = Math.abs(pp.y - a.y);
          if (dist < bestDist) { bestDist = dist; bestL = s2; }
        }
        if (bestDist > 80) return;
        var np = master.getPointAtLength(bestL);
        var ng = document.createElementNS(NS, 'g');
        ng.setAttribute('transform', 'translate(' + np.x.toFixed(1) + ',' + np.y.toFixed(1) + ')');
        var nb = document.createElementNS(NS, 'g');
        nb.setAttribute('class', 'gmg-sprig gmg-vine-node');
        var r = (mobile ? 3.6 : a.cta ? 6.4 : 5.2);
        nb.innerHTML = bloomMarkup(r, a.seed + bi * 5);
        nb.dataset.len = Math.round(bestL);
        ng.appendChild(nb);
        svg.appendChild(ng);
        vineSprigs.push(nb);
      });

      if (reduceMotion) {
        vineSegs.forEach(function (s3) { s3.el.style.strokeDashoffset = 0; });
        glow.style.strokeDashoffset = 0;
        vineSprigs.forEach(function (s) { s.classList.add('on'); });
      } else {
        vineGlow = glow;
        updateVine();
      }
    };

    var updateVine = function () {
      if (!vineSegs.length || reduceMotion) return;
      /* tip rides at ~58% of the viewport (was 92% — Joey: it went "too
         far down the viewpane"), converted from vertical px to
         path-length units since the meander is longer than its height */
      var grow = (window.scrollY + window.innerHeight * 0.58 - vineTopDoc) * (vineLen / vineHpx);
      grow = Math.max(0, Math.min(vineLen, grow));
      for (var i = 0; i < vineSegs.length; i++) {
        var sg2 = vineSegs[i];
        var local = Math.max(0, Math.min(sg2.len, grow - sg2.start));
        sg2.el.style.strokeDashoffset = sg2.len - local;
      }
      if (vineGlow) vineGlow.style.strokeDashoffset = glowLen * (1 - grow / vineLen);
      for (var k = 0; k < vineSprigs.length; k++) {
        var s = vineSprigs[k];
        if (!s._on && +s.dataset.len <= grow) { s.classList.add('on'); s._on = true; }
        else if (s._on && +s.dataset.len > grow + 40) { s.classList.remove('on'); s._on = false; }
      }
    };

    var vineTicking = false;
    var onVineScroll = function () {
      if (!vineTicking) { vineTicking = true; window.requestAnimationFrame(function () { vineTicking = false; updateVine(); }); }
    };
    var vineResizeT = null;
    var onVineResize = function () {
      clearTimeout(vineResizeT);
      vineResizeT = setTimeout(buildVine, 220);
    };
    var initVine = function () {
      buildVine();
      /* late layout shifts (webfonts, images) move the anchors — rebuild once */
      setTimeout(buildVine, 1600);
      if (!reduceMotion) {
        window.addEventListener('scroll', onVineScroll, { passive: true });
        window.addEventListener('resize', onVineResize);
      }
    };
    if (document.readyState === 'complete') initVine();
    else window.addEventListener('load', initVine);
  }

  /* ---- blog previews growing on a vine (task-0919/0920) ----
     The Learn-library strip: post cards hang side-by-side off a horizontal
     stem that meanders through the headroom band above the row, branches
     down to a bloom at each card, and pops leaf sprigs as it draws itself
     in the first time the strip scrolls into view. Same hand-drawn
     vocabulary as the task-0916 vine. Both breakpoints scroll the row
     horizontally (task-0920 r2); the stem svg spans scrollWidth so the
     vine rides along with the cards. */
  var postVine = document.querySelector('[data-post-vine]');
  if (postVine) {
    var pvSegs = [], pvSprigs = [], pvGlow = null, pvDrawn = false;

    /* task-0939: the desktop >3-post row (post-vine--scroll) latches trackpad
       gestures that have any horizontal component, stalling the page's
       vertical scroll until the pointer leaves the strip. When a wheel
       gesture is vertical-dominant, take it away from the container and
       scroll the page directly; horizontal-dominant gestures fall through
       untouched so the row's native scroll + snap still work. Mobile is
       touch-driven (touch scrolling never fires wheel), and the width guard
       keeps narrow pointer-driven windows on the default behavior. */
    postVine.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return; /* pinch-zoom */
      if (window.innerWidth < 900) return;
      if (!postVine.classList.contains('post-vine--scroll')) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      e.preventDefault();
      var dy = e.deltaY;
      if (e.deltaMode === 1) dy *= 16;
      else if (e.deltaMode === 2) dy *= window.innerHeight;
      window.scrollBy(0, dy);
    }, { passive: false });

    var buildPostVine = function () {
      var old = postVine.querySelector('.post-vine__stem');
      if (old) old.parentNode.removeChild(old);
      pvSegs = []; pvSprigs = []; pvGlow = null;

      var cards = Array.prototype.slice.call(postVine.querySelectorAll('.post-vine__card'));
      if (!cards.length) return;
      /* scrollWidth = clientWidth unless the >3-post desktop row side-scrolls
         (post-vine--scroll, task-0920 addendum) — then the stem spans the full
         scrollable run and rides along with the cards. */
      var W = postVine.scrollWidth, H = postVine.clientHeight;
      if (W < 40 || H < 120) return;
      var mobile = window.innerWidth < 900; /* matches the .post-vine breakpoint — sizing only:
         task-0920 r2 made mobile a horizontal side-scrolling row too, so the
         stem is always horizontal; mobile just draws it smaller. */
      var spineY = mobile ? 22 : 26;  /* horizontal stem y, inside the padding-top headroom */
      var pvRect = postVine.getBoundingClientRect();

      var wrap = document.createElement('div');
      wrap.className = 'post-vine__stem';
      wrap.setAttribute('aria-hidden', 'true');
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('width', W);
      svg.setAttribute('height', H);
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);

      /* waypoints: meander left-to-right along the headroom band, swing DOWN
         to a node just above each card's top edge (the bloom sits where the
         card "hangs" off the vine). Same geometry on both breakpoints since
         task-0920 r2 — mobile just scrolls a narrower row. */
      var pts = [], nodes = [];
      pts.push({ x: 2, y: spineY + 6 });
      var cursorX = 2, ampH = mobile ? 8 : 12;
      var addWigglesH = function (fromX, toX, seedBase) {
        var gap = toX - fromX;
        var n = Math.max(1, Math.round(gap / 150));
        for (var k = 1; k < n; k++) {
          pts.push({ x: fromX + gap * (k / n), y: spineY + (nz(seedBase + k) - 0.5) * 2 * ampH });
        }
      };
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        /* branch point drifts off-center per card so the row reads organic;
           scrollLeft matters when a rebuild fires mid-scroll */
        var x = r.left - pvRect.left + postVine.scrollLeft + r.width * (i % 2 === 0 ? 0.34 : 0.66);
        var nodeY = (r.top - pvRect.top) - 12;
        addWigglesH(cursorX, x, i * 11 + 3);
        pts.push({ x: x, y: nodeY });
        nodes.push({ x: x, y: nodeY, seed: i * 7 + 2 });
        cursorX = x;
      });
      addWigglesH(cursorX, W - 4, 71);
      pts.push({ x: W - 4, y: spineY + 2 });

      /* Catmull-Rom → cubic bezier, same as the gutter vine */
      var d = 'M' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[Math.max(0, i - 1)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(pts.length - 1, i + 2)];
        d += ' C' + (p1.x + (p2.x - p0.x) / 6).toFixed(1) + ' ' + (p1.y + (p2.y - p0.y) / 6).toFixed(1) +
          ', ' + (p2.x - (p3.x - p1.x) / 6).toFixed(1) + ' ' + (p2.y - (p3.y - p1.y) / 6).toFixed(1) +
          ', ' + p2.x.toFixed(1) + ' ' + p2.y.toFixed(1);
      }

      var master = document.createElementNS(NS, 'path');
      master.setAttribute('d', d);
      master.setAttribute('fill', 'none');
      master.setAttribute('stroke', 'none');
      svg.appendChild(master);

      var stemColor = isDarkBg(postVine.closest('.section') || document.body) ? MEADOW : PINE;

      var glow = document.createElementNS(NS, 'path');
      glow.setAttribute('d', d);
      glow.setAttribute('fill', 'none');
      glow.setAttribute('stroke', 'rgba(166,196,142,.24)');
      glow.setAttribute('stroke-width', mobile ? 4.5 : 7);
      glow.setAttribute('stroke-linecap', 'round');
      svg.appendChild(glow);

      var masterLen = master.getTotalLength();
      var samples = [];
      for (var sL = 0; sL < masterLen; sL += 6) samples.push(master.getPointAtLength(sL));
      samples.push(master.getPointAtLength(masterLen));
      var SEGN = 6, DRAW = 2.1;
      var wBase = mobile ? 3 : 4.4, wTip = mobile ? 1.4 : 1.8;
      for (var si = 0; si < SEGN; si++) {
        var i0 = Math.floor(si * (samples.length - 1) / SEGN);
        var i1 = Math.floor((si + 1) * (samples.length - 1) / SEGN);
        var dd = 'M' + samples[i0].x.toFixed(1) + ' ' + samples[i0].y.toFixed(1);
        for (var j = i0 + 1; j <= i1; j++) dd += 'L' + samples[j].x.toFixed(1) + ' ' + samples[j].y.toFixed(1);
        var sp = document.createElementNS(NS, 'path');
        sp.setAttribute('d', dd);
        sp.setAttribute('fill', 'none');
        sp.setAttribute('stroke', stemColor);
        sp.setAttribute('stroke-width', (wBase + (wTip - wBase) * (si / (SEGN - 1))).toFixed(2));
        sp.setAttribute('stroke-linecap', 'round');
        sp.setAttribute('stroke-linejoin', 'round');
        svg.appendChild(sp);
        var segLen = sp.getTotalLength();
        sp.style.strokeDasharray = segLen;
        sp.style.strokeDashoffset = pvDrawn || reduceMotion ? 0 : segLen;
        if (!reduceMotion && !pvDrawn) {
          sp.style.transition = 'stroke-dashoffset ' + (DRAW / SEGN + 0.06).toFixed(2) + 's linear ' + (si * DRAW / SEGN).toFixed(2) + 's';
        }
        pvSegs.push(sp);
      }
      glow.style.strokeDasharray = masterLen;
      glow.style.strokeDashoffset = pvDrawn || reduceMotion ? 0 : masterLen;
      if (!reduceMotion && !pvDrawn) glow.style.transition = 'stroke-dashoffset ' + DRAW + 's linear';
      pvGlow = glow;

      /* leaf sprigs along the stem, clear of the card blooms —
         distance measured along x, the spine axis on both breakpoints */
      var nearNode = function (p) {
        for (var q = 0; q < nodes.length; q++) {
          if (Math.abs(nodes[q].x - p.x) < 60) return true;
        }
        return false;
      };
      var addPop = function (g, L) {
        if (!reduceMotion && !pvDrawn) g.style.transitionDelay = (L / masterLen * DRAW + 0.12).toFixed(2) + 's';
        else g.classList.add('on');
        pvSprigs.push(g);
      };
      var side = 1, li = 0;
      var step = mobile ? 150 : 130;
      for (var L = 46; L < masterLen - 50; L += step) {
        var pA = master.getPointAtLength(L);
        if (nearNode(pA)) continue;
        var pB = master.getPointAtLength(Math.min(masterLen, L + 8));
        var ang = Math.atan2(pB.y - pA.y, pB.x - pA.x) * 180 / Math.PI;
        var outer = document.createElementNS(NS, 'g');
        outer.setAttribute('transform', 'translate(' + pA.x.toFixed(1) + ',' + pA.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
        var sg = document.createElementNS(NS, 'g');
        sg.setAttribute('class', 'gmg-sprig');
        var sc = (mobile ? 0.62 : 0.95) * (0.8 + 0.4 * nz(li + 23));
        var kind = li % 3;
        sg.innerHTML = kind === 0 ? leafSimple(stemColor, side, sc)
          : kind === 1 ? leafPair(stemColor, side, sc * 0.9)
            : tendril(stemColor, side, sc);
        outer.appendChild(sg);
        svg.appendChild(outer);
        addPop(sg, L);
        side *= -1; li++;
      }
      /* a bloom where the stem meets each card */
      nodes.forEach(function (n2, bi) {
        var bestL = 0, bestDist = Infinity;
        for (var s2 = 0; s2 <= masterLen; s2 += 14) {
          var pp = master.getPointAtLength(s2);
          var dist = Math.abs(pp.x - n2.x);
          if (dist < bestDist) { bestDist = dist; bestL = s2; }
        }
        var np = master.getPointAtLength(bestL);
        var ng = document.createElementNS(NS, 'g');
        ng.setAttribute('transform', 'translate(' + np.x.toFixed(1) + ',' + np.y.toFixed(1) + ')');
        var nb = document.createElementNS(NS, 'g');
        nb.setAttribute('class', 'gmg-sprig');
        nb.innerHTML = bloomMarkup(mobile ? 4.4 : 6, n2.seed + bi * 5);
        ng.appendChild(nb);
        svg.appendChild(ng);
        addPop(nb, bestL);
      });

      wrap.appendChild(svg);
      postVine.appendChild(wrap);
    };

    var growPostVine = function () {
      if (pvDrawn) return;
      pvDrawn = true;
      pvSegs.forEach(function (s) { s.style.strokeDashoffset = 0; });
      if (pvGlow) pvGlow.style.strokeDashoffset = 0;
      pvSprigs.forEach(function (s) { s.classList.add('on'); });
      /* cards past the scroll edge never reach the page reveal observer's
         0.12 threshold (the next-card peek is only ~30px), which left the
         peek invisible and killed the swipe affordance — so reveal every
         card in the strip, staggered, as soon as the vine grows in. */
      Array.prototype.forEach.call(postVine.querySelectorAll('.post-vine__card.reveal'), function (c, ci) {
        var cd = 0.12 * ci;
        c.style.transitionDelay = cd.toFixed(2) + 's';
        c.classList.add('is-in');
        setTimeout(function () { settle(c); }, cd * 1000 + 1000);
      });
    };

    var initPostVine = function () {
      buildPostVine();
      /* webfonts/images settle late — rebuild once, preserving drawn state */
      setTimeout(buildPostVine, 1600);
      if (reduceMotion || !('IntersectionObserver' in window)) {
        pvDrawn = true;
        pvSprigs.forEach(function (s) { s.classList.add('on'); });
      } else {
        var pvIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { growPostVine(); pvIO.disconnect(); }
          });
        }, { threshold: 0.18 });
        pvIO.observe(postVine);
        var pvResizeT = null;
        window.addEventListener('resize', function () {
          clearTimeout(pvResizeT);
          pvResizeT = setTimeout(buildPostVine, 240);
        });
      }
    };
    if (document.readyState === 'complete') initPostVine();
    else window.addEventListener('load', initPostVine);
  }

  /* ---- garden accents (task-0916) ----
     Two motifs beyond the vine, drawn from the same botanical vocabulary
     so the whole site reads as one garden:
     1. corner sprigs — a hand-drawn stem + leaves + berry cluster that
        draws itself in at the corner of key bands (statement, garden
        band, the newsletter band, and inner-page heroes);
     2. a drift layer — a few leaves/petals swaying very slowly in the
        hero, like the canopy is just overhead.
     Both are aria-hidden, pointer-transparent, and freeze politely under
     prefers-reduced-motion (the global media query zeroes durations). */
  var buildAccents = function () {
    var cornerSVG = function (leafFill, seed) {
      return '<svg viewBox="0 0 110 110" width="100%" height="100%" fill="none" xmlns="' + NS + '">' +
        '<path class="gmg-corner-stem" d="M4 106 C26 88, 22 60, 40 42 C54 28, 74 22, 96 20" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>' +
        '<path class="gmg-corner-stem gmg-corner-stem--b" d="M30 68 C42 64, 52 66, 60 74" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '<g transform="translate(16,86) rotate(-30)"><g class="gmg-corner-leaf">' + leafSimple(leafFill, 1, 1.15) + '</g></g>' +
        '<g transform="translate(33,52) rotate(-55)"><g class="gmg-corner-leaf">' + leafPair(leafFill, -1, 0.95) + '</g></g>' +
        '<g transform="translate(62,26) rotate(-85)"><g class="gmg-corner-leaf">' + leafSimple(leafFill, 1, 0.9) + '</g></g>' +
        '<g transform="translate(88,22) rotate(70)"><g class="gmg-corner-leaf">' + tendril(leafFill, 1, 0.85) + '</g></g>' +
        '<g class="gmg-corner-berry">' +
        '<circle cx="60" cy="76" r="3.4" fill="' + BLOOM + '" stroke="' + DEEP + '" stroke-width=".8" stroke-opacity=".35"/>' +
        '<circle cx="68" cy="80" r="2.5" fill="' + BLOOM + '" fill-opacity=".85"/>' +
        '<circle cx="65" cy="71" r="1.9" fill="' + SUN + '"/>' +
        '</g></svg>';
    };
    var corners = [];
    var addCorner = function (host, pos) {
      if (!host) return;
      var dark = isDarkBg(host);
      var el = document.createElement('div');
      el.className = 'gmg-corner gmg-corner--' + pos;
      el.setAttribute('aria-hidden', 'true');
      el.style.color = dark ? MEADOW : PINE;
      el.innerHTML = cornerSVG(dark ? MEADOW : PINE, corners.length);
      host.appendChild(el);
      corners.push(el);
    };

    if (document.body.classList.contains('template-index')) {
      var homeSections = document.querySelectorAll('.section, .garden-band');
      if (homeSections.length) addCorner(homeSections[0], 'tr');           /* statement band */
      addCorner(document.querySelector('.garden-band'), 'br');
      var nlForm = document.querySelector('.newsletter__form');
      if (nlForm) {
        var nlSec = nlForm.closest('.section');
        /* skip if it's the footer form — the footer has its own texture */
        if (nlSec) addCorner(nlSec, 'tr');
      }
    }
    document.querySelectorAll('.page-hero').forEach(function (ph) {
      addCorner(ph, 'bl');
      addCorner(ph, 'tr');
    });

    /* task-0921 r2: richly frame the "Let's help your child flourish" CTA band
       — Joey found two lone accents too sparse. All four corners get the
       hand-drawn corner sprig (stem + leaves + berry), auto-colored MEADOW on
       the dark band; bottom corners drop out on the narrowest screens so the
       centered copy/CTA stay clear. Draws in via the shared corner IO below. */
    document.querySelectorAll('.cta-band').forEach(function (band) {
      addCorner(band, 'tl');
      addCorner(band, 'tr');
      if (window.innerWidth >= 700) {
        addCorner(band, 'bl');
        addCorner(band, 'br');
      }
    });

    /* ---- seam garlands (task-0921) ----
       Joey: the transitions between sections "feel a little empty". At
       chosen boundaries a hand-drawn stem grows in from the page edge and
       lies along the seam — leaves, a tendril, a small bloom, same
       vocabulary as everything else — then sways almost imperceptibly.
       Each garland is anchored to the LOWER section of its boundary
       (straddling the line via CSS) and colored for that background.
       Edges alternate down the page and stay clear of the existing corner
       sprigs (garden-band br, newsletter tr). Shares the corner sprigs'
       draw-in IntersectionObserver. */
    var seamSVG = function (fill, seed) {
      var stroke = fill === MEADOW ? MEADOW : PINE;
      var d = function (delay, inner) {
        return '<g class="gmg-seam-leaf" style="transition-delay:' + delay + 's">' + inner + '</g>';
      };
      return '<svg viewBox="0 0 235 64" width="100%" height="100%" fill="none" xmlns="' + NS + '">' +
        '<g class="gmg-seam__sway">' +
        '<path class="gmg-seam-stem" d="M0 34 C28 26, 52 40, 84 32 C112 25, 142 36, 172 30 C186 27.5, 198 29, 210 31" stroke="' + stroke + '" stroke-width="2.2" stroke-linecap="round"/>' +
        '<path class="gmg-seam-stem gmg-seam-stem--b" d="M58 33 C70 41, 84 44, 98 41" stroke="' + stroke + '" stroke-width="1.6" stroke-linecap="round"/>' +
        '<g transform="translate(36,30) rotate(-14)">' + d(0.9, leafSimple(fill, 1, 0.92 + 0.12 * nz(seed))) + '</g>' +
        '<g transform="translate(86,31) rotate(-6)">' + d(1.05, leafPair(fill, 1, 0.82)) + '</g>' +
        '<g transform="translate(124,34) rotate(158)">' + d(1.18, leafSimple(fill, -1, 0.72)) + '</g>' +
        '<g transform="translate(166,29) rotate(-10)">' + d(1.3, tendril(stroke, 1, 0.9)) + '</g>' +
        '<g transform="translate(98,41)">' + d(1.42, bloomMarkup(4.2, seed)) + '</g>' +
        '<g transform="translate(196,32) rotate(150)">' + d(1.5, leafSimple(fill, -1, 0.55)) + '</g>' +
        '</g></svg>';
    };
    var addSeam = function (host, side, seed) {
      if (!host) return;
      var el = document.createElement('div');
      el.className = 'gmg-seam gmg-seam--' + side;
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = seamSVG(isDarkBg(host) ? MEADOW : PINE, seed * 13 + 3);
      host.appendChild(el);
      corners.push(el);
    };
    /* ---- centered seam medallions (task-0914; r3 rules) ----
       Joey r3: a medallion belongs ONLY on a hard-cut seam (an abrupt
       color change, e.g. dark↔light) — smooth/gradient/wave transitions
       get none. It must straddle the seam line perfectly 50/50, and it
       REPLACES the edge garland on that seam rather than joining it.
       The art is duotone, clipped exactly at the seam: the half over the
       upper band is colored for the upper band, the half below for the
       lower — which is what lets it sit truly centered on a harsh cut
       without either half washing out (the old fix biased the whole node
       onto its own band, which read as "cut off by the section above"). */
    var medallionHalf = function (fill, stroke, seed) {
      var d = function (delay, inner) {
        return '<g class="gmg-seam-leaf" style="transition-delay:' + delay + 's">' + inner + '</g>';
      };
      var lift = (26.5 + nz(seed) * 3.5).toFixed(1);
      return '<path class="gmg-seam-stem" d="M95 35 C80 ' + lift + ', 62 41, 44 34 C34 30.5, 22 33, 12 35" stroke="' + stroke + '" stroke-width="2.1" stroke-linecap="round"/>' +
        '<g transform="translate(62,33) rotate(' + (-6 - nz(seed + 2) * 8).toFixed(0) + ')">' + d(0.85, leafPair(fill, 1, 0.72 + nz(seed + 4) * 0.14)) + '</g>' +
        '<g transform="translate(36,31) rotate(' + (162 + nz(seed + 6) * 12).toFixed(0) + ')">' + d(1.0, leafSimple(fill, -1, 0.62)) + '</g>' +
        '<g transform="translate(16,34) rotate(-12)">' + d(1.15, tendril(stroke, 1, 0.68)) + '</g>' +
        '<g transform="translate(79,40)">' + d(1.25,
          '<circle r="2.6" fill="' + BLOOM + '" fill-opacity=".85"/><circle cx="6.5" cy="-3" r="1.8" fill="' + SUN + '"/>') + '</g>';
    };
    var medClipId = 0;
    var medallionSVG = function (fillTop, fillBottom, seed) {
      var tilt = (nz(seed + 9) * 4 - 2).toFixed(1);
      var body = function (fill) {
        var stroke = fill === MEADOW ? MEADOW : PINE;
        return '<g transform="rotate(' + tilt + ' 95 35)">' +
          medallionHalf(fill, stroke, seed) +
          '<g transform="translate(190,0) scale(-1,1)">' + medallionHalf(fill, stroke, seed + 3) + '</g>' +
          '</g>';
      };
      var cid = 'gmgmed' + (medClipId++);
      /* the element is centered on the seam, so the seam line crosses the
         viewBox at y=35 — clip the art there and color each half for the
         band it actually sits on */
      return '<svg viewBox="0 0 190 70" width="100%" height="100%" fill="none" xmlns="' + NS + '">' +
        '<defs>' +
        '<clipPath id="' + cid + 't"><rect x="-25" y="-25" width="240" height="60"/></clipPath>' +
        '<clipPath id="' + cid + 'b"><rect x="-25" y="35" width="240" height="60"/></clipPath>' +
        '</defs>' +
        '<g class="gmg-seam__sway gmg-seam__sway--center">' +
        '<g clip-path="url(#' + cid + 't)">' + body(fillTop) + '</g>' +
        '<g clip-path="url(#' + cid + 'b)">' + body(fillBottom) + '</g>' +
        '<g transform="rotate(' + tilt + ' 95 35)"><g transform="translate(95,35)"><g class="gmg-seam-leaf" style="transition-delay:1.4s">' + bloomMarkup(6.4, seed) + '</g></g></g>' +
        '</g></svg>';
    };
    /* mount every medallion on the LOWER section's .shopify-section wrapper
       (never the inner host): the wrapper's top edge IS the seam line and no
       wrapper clips, so top:0 + translateY(-50%) is a true 50/50 straddle —
       this also generalizes the r2 garden-band/cta-band clip fix to any host
       with overflow:hidden, since the node never lives inside a host at all. */
    var addMedallion = function (wrap, upperDark, lowerDark, seed) {
      var el = document.createElement('div');
      el.className = 'gmg-seam gmg-seam--center';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = medallionSVG(upperDark ? MEADOW : PINE, lowerDark ? MEADOW : PINE, seed * 7 + 5);
      wrap.classList.add('gmg-seam-host');
      wrap.appendChild(el);
      corners.push(el);
    };
    /* walk every interior boundary (all templates): a medallion goes only
       where both bands have a knowable flat color and the cut is harsh.
       Photo bands (effLum null) and wave-topped sections are smooth by
       definition; Δ<0.25 luminance is a soft cream↔pastel blend. */
    var HOST_SEL = '.section, .garden-band, .page-hero, .article, .cta-band';
    var wraps = [].filter.call(document.querySelectorAll('#MainContent > .shopify-section'), function (w) {
      return w.getBoundingClientRect().height > 4;
    });
    var medWraps = [];
    for (var bi = 1; bi < wraps.length; bi++) {
      var upperHost = wraps[bi - 1].querySelector(HOST_SEL) || wraps[bi - 1];
      var lowerHost = wraps[bi].querySelector(HOST_SEL) || wraps[bi];
      if (lowerHost.querySelector('.divider-wave')) continue;
      var lu = effLum(upperHost), ll = effLum(lowerHost);
      if (lu == null || ll == null || Math.abs(lu - ll) < 0.25) continue;
      addMedallion(wraps[bi], lu < 0.5, ll < 0.5, bi);
      medWraps.push(wraps[bi]);
    }
    /* edge garlands (task-0921) go on the remaining seams — never on one
       that carries a centered medallion (r3: centered REPLACES side). */
    var hasMedallion = function (el) {
      return !!el && medWraps.indexOf(el.closest('.shopify-section')) !== -1;
    };
    if (document.body.classList.contains('template-index')) {
      [
        { sel: '.shopify-section[id$="__annetta"] .section', side: 'right' },
        { sel: '.shopify-section[id$="__village"] .section', side: 'left' },
        { sel: '.shopify-section[id$="__blog"] .section', side: 'right' },
        { sel: '.shopify-section[id$="__newsletter"] .section', side: 'left' }
      ].forEach(function (t, i) {
        var host = document.querySelector(t.sel);
        if (hasMedallion(host)) return;
        addSeam(host, t.side, i);
      });
    } else {
      /* task-0921 r2: every OTHER template gets the same seam treatment at its
         interior section boundaries, so the whole site reads as one garden and
         not just the homepage. Walk the section wrappers in DOM order; anchor a
         garland to the top of each section after the first (the hero, which
         already carries corner sprigs + drift), alternating edges. Skip empty
         wrappers (e.g. the gated booking hero) and the CTA band (framed by its
         own four corners above). */
      var placed = 0;
      for (var si = 1; si < wraps.length; si++) {
        var host = wraps[si].querySelector('.section, .garden-band, .page-hero, .article');
        if (!host || host.classList.contains('cta-band') || hasMedallion(host)) continue;
        addSeam(host, placed % 2 === 0 ? 'right' : 'left', placed);
        placed++;
      }
    }

    if (corners.length) {
      if ('IntersectionObserver' in window && !reduceMotion) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-drawn'); cio.unobserve(e.target); }
          });
        }, { threshold: 0.3 });
        corners.forEach(function (c) { cio.observe(c); });
      } else {
        corners.forEach(function (c) { c.classList.add('is-drawn'); });
      }
    }

    /* drift layer: slow leaves/petals over a band. Hero (home + inner)
       since task-0916; task-0921 adds a lighter one to the garden band so
       the mid-page keeps the "canopy overhead" feeling. Spots hug the
       edges so nothing drifts over copy. */
    var addDrift = function (driftHost, spots, seedBase, mobileCount, mobileSpots) {
      if (!driftHost) return;
      var drift = document.createElement('div');
      drift.className = 'gmg-drift';
      drift.setAttribute('aria-hidden', 'true');
      var dark = isDarkBg(driftHost);
      var narrow = window.innerWidth < 700;
      if (narrow && mobileSpots) spots = mobileSpots;
      var count = narrow ? Math.min(mobileCount, spots.length) : spots.length;
      for (var di = 0; di < count; di++) {
        var item = document.createElement('span');
        item.className = 'gmg-drift__item';
        item.style.left = spots[di].l + '%';
        item.style.top = spots[di].t + '%';
        item.style.setProperty('--dur', (15 + nz(di + seedBase + 21) * 9).toFixed(1) + 's');
        item.style.setProperty('--del', (-nz(di + seedBase + 51) * 12).toFixed(1) + 's');
        var sc = 0.85 + nz(di + seedBase + 71) * 0.5;
        var fill = dark ? MEADOW : PINE;
        var art = di % 2 === 0 ? leafSimple(fill, di % 4 < 2 ? 1 : -1, sc)
          : '<ellipse cx="0" cy="-7" rx="4.6" ry="7.4" transform="rotate(' + (nz(di + seedBase) * 60 - 30).toFixed(0) + ')" fill="' + BLOOM + '" fill-opacity=".75" stroke="' + DEEP + '" stroke-width=".7" stroke-opacity=".3"/>';
        item.innerHTML = '<svg width="46" height="46" viewBox="-23 -34 46 46" fill="none" xmlns="' + NS + '">' + art + '</svg>';
        drift.appendChild(item);
      }
      driftHost.appendChild(drift);
    };
    addDrift(document.querySelector('.page-hero'),
      [{ l: 6, t: 22 }, { l: 12, t: 64 }, { l: 88, t: 30 }, { l: 93, t: 68 }], 0, 3);
    if (document.body.classList.contains('template-index')) {
      /* mobile spots sit in the whitespace gaps so nothing grazes the
         centered copy at 390px */
      addDrift(document.querySelector('.garden-band'),
        [{ l: 5, t: 16 }, { l: 92, t: 20 }, { l: 4, t: 74 }], 7, 2,
        [{ l: 2, t: 30 }, { l: 87, t: 26 }]);
    }
  };
  if (document.readyState !== 'loading') buildAccents();
  else document.addEventListener('DOMContentLoaded', buildAccents);

  /* ---- newsletter: friendly inline success for any actionless [data-newsletter] form ---- */
  document.querySelectorAll('[data-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // If no real action set yet, prevent + show placeholder success.
      if (!form.getAttribute('action') || form.getAttribute('action') === '#') {
        e.preventDefault();
        var note = form.parentNode.querySelector('[data-newsletter-success]');
        if (note) { note.hidden = false; form.hidden = true; }
      }
    });
  });

  /* ---- lead-magnet choice (task-1014) ----
     Delivery moved off-page: Shopify customer tags on the selected resource
     power Shopify Email automations. The old sessionStorage reveal fallback
     intentionally showed both PDF links when the chosen guide could not be
     recovered after Shopify's full POST + reload; that path is removed. */
  try { sessionStorage.removeItem('gmg-magnet'); } catch (e) {}

  /* ---- "one question" chips (task-0914, audit D8) ----
     The mockup-3 product-philosophy module: five pastel question chips a
     visitor can light up. Purely playful/pre-launch — no data captured.
     Toggling a chip pops a tiny bloom from its corner (one-shot, removed
     after the animation) and, once anything is lit, the kicker line warms
     up via a class on the section. */
  document.querySelectorAll('[data-question-module]').forEach(function (mod) {
    var chips = mod.querySelectorAll('.q-chip');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', on ? 'false' : 'true');
        if (!on) {
          var pop = document.createElement('span');
          pop.className = 'q-chip__pop';
          pop.setAttribute('aria-hidden', 'true');
          chip.appendChild(pop);
          setTimeout(function () { pop.remove(); }, 900);
        }
        var anyOn = false;
        chips.forEach(function (c) { if (c.getAttribute('aria-pressed') === 'true') anyOn = true; });
        mod.classList.toggle('q-module--lit', anyOn);
      });
    });
  });

  /* ---- booking coming-soon modal (task-0922) ----
     While the booking_coming_soon theme setting is ON (the dialog only
     renders then), any click on a link to SimplePractice or the booking
     page opens the coming-soon + waitlist dialog instead of navigating.
     Links keep real hrefs, so no-JS visitors land on /pages/booking which
     shows the same message (sections/booking-coming-soon.liquid). The
     Shopify-fallback waitlist form reloads the page on submit, so if the
     dialog holds a fresh success message we reopen it to show it. */
  var bookingModal = document.querySelector('dialog[data-booking-modal]');
  if (bookingModal && typeof bookingModal.showModal === 'function') {
    var bookingUrl = bookingModal.getAttribute('data-booking-url') || '';
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var isBooking = href.indexOf('/pages/booking') === 0 ||
        (bookingUrl && href.indexOf(bookingUrl) === 0);
      if (!isBooking) return;
      e.preventDefault();
      bookingModal.showModal();
    });
    bookingModal.addEventListener('click', function (e) {
      if (e.target === bookingModal) bookingModal.close(); /* backdrop click */
    });
    var bmClose = bookingModal.querySelector('[data-booking-modal-close]');
    if (bmClose) bmClose.addEventListener('click', function () { bookingModal.close(); });
    var bmForm = bookingModal.querySelector('.newsletter__form');
    if (bmForm) bmForm.addEventListener('submit', function () {
      try { sessionStorage.setItem('gmg-booking-submitted', '1'); } catch (err) {}
    });
    var bmSubmitted = '';
    try { bmSubmitted = sessionStorage.getItem('gmg-booking-submitted') || ''; } catch (err) {}
    if (bmSubmitted && bookingModal.querySelector('.form-success')) bookingModal.showModal();
    try { sessionStorage.removeItem('gmg-booking-submitted'); } catch (err) {}
  }

  /* ---- coming-soon gates: products + Learn library (task-1012) ----
     While collection_coming_soon / blog_coming_soon are ON the real templates
     are already swapped server-side for the email-capture gate (snippets/
     coming-soon-gate.liquid) — this block only upgrades in-page clicks into
     gated territory to a dialog instead of a navigation. Each open folds
     coming-soon + cs-<dest> + a src-* tag (where on the page the click
     happened) into the shared intake form's contact[tags] radios — the same
     folding trick as the hub notify modal — so signups are countable by
     entry point in Shopify admin. Links keep real hrefs: no-JS visitors land
     on the template-level gate, tagged src-direct. */
  var csModal = document.querySelector('dialog[data-cs-modal]');
  if (csModal && typeof csModal.showModal === 'function') {
    var csGateProducts = csModal.hasAttribute('data-cs-gate-products');
    var csGateBlog = csModal.hasAttribute('data-cs-gate-blog');
    var csForm = csModal.querySelector('.newsletter__form');
    var csRadios = csForm ? csForm.querySelectorAll('input[name="contact[tags]"]') : [];
    csRadios.forEach(function (r) { r.dataset.csBase = r.value; });
    var csVariants = csModal.querySelectorAll('[data-cs-variant]');
    var csShowVariant = function (dest) {
      csVariants.forEach(function (v) { v.hidden = v.getAttribute('data-cs-variant') !== dest; });
    };
    var csDestFor = function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return null;
      var url;
      try { url = new URL(href, window.location.origin); } catch (e) { return null; }
      if (url.origin !== window.location.origin) return null;
      var path = url.pathname;
      if (csGateProducts && (path.indexOf('/collections') === 0 || path.indexOf('/products/') === 0 || path === '/pages/garden-collection')) return 'products';
      if (csGateBlog && path.indexOf('/blogs') === 0) return 'blog';
      return null;
    };
    var csSourceFor = function (a) {
      if (a.closest('.hero-brand__paths')) return 'hero-card';
      if (a.closest('.mobile-nav')) return 'mobile-nav';
      if (a.closest('.site-header')) return 'header-nav';
      if (a.closest('.site-footer')) return 'footer';
      if (a.closest('.blog-preview')) return 'learn-preview';
      if (a.closest('.hub-showcase')) return 'hub-page';
      return 'page-link';
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || csModal.contains(a)) return;
      var dest = csDestFor(a);
      if (!dest) return;
      e.preventDefault();
      csShowVariant(dest);
      var src = csSourceFor(a);
      csRadios.forEach(function (r) {
        r.value = r.dataset.csBase + ',coming-soon,cs-' + dest + ',src-' + src;
      });
      try { sessionStorage.setItem('gmg-cs-dest', dest); } catch (err) {}
      csModal.showModal();
    });
    csModal.addEventListener('click', function (e) {
      if (e.target === csModal) csModal.close(); /* backdrop click */
    });
    var csCloseBtn = csModal.querySelector('[data-cs-close]');
    if (csCloseBtn) csCloseBtn.addEventListener('click', function () { csModal.close(); });
    /* The customer form reloads the page on submit. Reopen this dialog on the
       success view only when it initiated the submit (own flag — successes
       from other forms on the page must not pop it; note the booking modal's
       looser .form-success check can also fire on our submit, so close it). */
    if (csForm) csForm.addEventListener('submit', function () {
      try { sessionStorage.setItem('gmg-cs-submitted', '1'); } catch (err) {}
    });
    var csSubmitted = '';
    try { csSubmitted = sessionStorage.getItem('gmg-cs-submitted') || ''; } catch (err) {}
    if (csSubmitted && csModal.querySelector('.form-success')) {
      var csDest = 'products';
      try { csDest = sessionStorage.getItem('gmg-cs-dest') || 'products'; } catch (err) {}
      var openBooking = document.querySelector('dialog[data-booking-modal][open]');
      if (openBooking) openBooking.close();
      csShowVariant(csDest);
      csModal.showModal();
    }
    try { sessionStorage.removeItem('gmg-cs-submitted'); sessionStorage.removeItem('gmg-cs-dest'); } catch (err) {}
  }

})();
